<template>
  <div class="swiper-contain">
    <Swiper
      :slidesPerView="3"
      :spaceBetween="27"
      :loop="true"
      :autoplay="{
        delay: 3000,
        disableOnInteraction: false,
      }"
      :navigation="{
        nextEl: '.right-btn',
        prevEl: '.left-btn',
      }"
      :pagination="{
        clickable: true,
      }"
    >
      <SwiperSlide v-for="(swiperItem, key) in swiperList" :key="key">
        <div class="swiper-card" @click="navigation(swiperItem.url)">
          <img class="img" :src="swiperItem.imgUrl" alt="" />
          <div class="card-info">
            <div class="title">{{ swiperItem.title }}</div>
            <div class="sub-title">{{ swiperItem.subTitle }}</div>
            <div class="price">
              <div class="price-text">
                {{ swiperItem.price }}
              </div>
              <img
                v-if="swiperItem.showArrow"
                class="arrow"
                src="https://editor.xesimg.com/tailor/resource/%E7%AE%AD%E5%A4%B4%E7%BA%A2%E8%89%B2-1702288177700.png"
                alt=""
                srcset=""
              />
            </div>
          </div>
        </div>
      </SwiperSlide>
    </Swiper>
    <div class="left-btn"></div>
    <div class="right-btn"></div>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Navigation, Autoplay } from "swiper";
import "swiper/swiper.less";
const modules = [Navigation, Autoplay];
SwiperCore.use(modules);

const swiperList = [
  {
    imgUrl:
      "https://editor.xesimg.com/tailor/resource/Maskgroup2-1702288043160.png",
    title: "我们的故事",
    subTitle: "又上新闻了！点击查看“双胞胎学霸”养成记",
    price: "去了解",
    url: "https://mp.weixin.qq.com/s/4Dlt36Rvemc9zoOMWDq7-g",
    showArrow: true,
  },
  {
    imgUrl: "https://editor.xesimg.com/tailor/resource/tu4-1702215277312.png",
    title: "摩比爱数学",
    subTitle: "畅销超400万册的思维启蒙网红图书",
    price: "￥135元起",
    url: "https://item.m.jd.com/product/12462969.html?utm_user=plusmember&gx=RnAoFtr-vppoEx2BeDD3ERk56Q&gxd=RnAoxmEPbWWKmMkRroB0WdNvUk9xpwE&ad_od=share&utm_source=androidapp&utm_medium=appshare&utm_campaign=t_335139774&utm_term=CopyURL",
  },
  {
    imgUrl: "https://editor.xesimg.com/tailor/resource/tu1-1702215277308.png",
    title: "摩比思维机",
    subTitle: "2-8岁儿童启蒙神器",
    price: "￥129元起",
    url: "https://item.m.jd.com/product/13973608.html?utm_source=iosapp&utm_medium=appshare&utm_campaign=t_335139774&utm_term=CopyURL&ad_od=share&gx=RnAonyIKMWWFkt0Upox-EdCzKQ&gxd=RnAolTRfYTDczZ1Hr9IkWttUYHCwLlhwsn9FvQCVMeyh9yjP1eICsmJOpFwY-Gk",
  },
  {
    imgUrl: "https://editor.xesimg.com/tailor/resource/tu3-1702215277312.png",
    title: "学而思秘籍",
    subTitle: "思维培养、基础巩固",
    price: "￥41.7元起",
    url: "https://item.m.jd.com/product/13808419.html?utm_source=iosapp&utm_medium=appshare&utm_campaign=t_335139774&utm_term=CopyURL&ad_od=share&gx=RnAonyIKMWWFkt0Upox-EdCzKQ&gxd=RnAolTRfYTDczZ1Hr9IkWttUYHCwLlhwsn9FvQCVMeyh9yjP1eICsmJOpFwY-Gk",
  },
];

const navigation = (url) => {
  window.open(url, "_blank");
};
</script>

<style scoped lang="less">
.swiper-contain {
  width: 1200px;
  margin: 40px auto;
  position: relative;
  .swiper-card {
    width: 382px;
    height: 340px;
    cursor: pointer;
    border-radius: 10px;
    .img {
      width: 382px;
      height: 211px;
      display: block;
    }
    .card-info {
      display: flex;
      width: 382px;
      flex-direction: column;
      align-items: center;
      height: 122px;
      background: #fff;
      border-radius: 0 0 10px 10px;
      box-shadow: 4px 4px 4px rgba(220, 220, 220, 0.25),
        -4px -4px 4px rgba(220, 220, 220, 0.25);
      // filter: drop-shadow(0px 4px 4px rgba(220, 220, 220, 0.25));
    }
    .title {
      margin-top: 22px;
      color: #000;
      font-family: PingFang SC;
      font-size: 22px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px; /* 50.638% */
    }
    .sub-title {
      margin-top: 13px;
      color: rgba(0, 0, 0, 0.8);
      font-family: PingFang SC;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px; /* 69.628% */
    }
    .price {
      margin-top: 18px;
      color: #ec2226;
      font-family: PingFang SC;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 18px; /* 69.628% */
      letter-spacing: 2.24px;
      display: flex;
      align-items: center;

      .price-text {
        margin-right: 8px;
      }
      .arrow {
        width: 9px;
        height: 13px;
      }
    }
  }
  .left-btn {
    position: absolute;
    z-index: 11;
    width: 52px;
    height: 52px;
    top: 50%;
    transform: translateY(-50%);
    left: -78px;
    cursor: pointer;
    background: url("https://editor.xesimg.com/tailor/resource/%E5%B7%A6-icon-1702190214465.png");
    background-size: 100% 100%;
  }
  .right-btn {
    cursor: pointer;
    position: absolute;
    z-index: 11;
    top: 50%;
    transform: translateY(-50%);
    right: -78px;
    width: 52px;
    height: 52px;
    background: url("https://editor.xesimg.com/tailor/resource/%E5%8F%B3-icon-1702190214462.png");
    background-size: 100% 100%;
  }
}
</style>

<style lang="less">
.swiper-container {
  padding: 0 5px;
}
</style>
